import { Loader2, Save, Send } from "lucide-react";
import { Button } from "@/components/ui/button";

export const ContractActions = ({ position, onSaveDraft, onPublish, saving, canPublish, hasContent, status }) => (
  <div className={`min-w-0 flex gap-2 ${position === "top" ? "flex-col items-end text-right" : "flex-wrap items-center justify-between"}`}
    data-testid={`contract-actions-${position}`}>
    <p className="min-w-0 text-xs text-[#707070]" data-testid={`contract-save-status-${position}`}>{status}</p>
    <div className="grid w-full grid-cols-2 gap-2 sm:flex sm:w-auto">
      <Button type="button" variant="outline" onClick={onSaveDraft}
        disabled={!!saving || !hasContent} className="min-w-0 border-[#C5B39B] text-[#1A1A1A] hover:bg-[#F7F4EE]"
        data-testid={position === "top" ? "contract-save-draft-button" : "contract-save-draft-button-bottom"}>
        {saving === "draft" ? <Loader2 className="animate-spin" /> : <Save />}
        Salva bozza
      </Button>
      <Button type="button" onClick={onPublish} disabled={!!saving || !canPublish}
        className="min-w-0 bg-[#1A1A1A] text-white hover:bg-black"
        data-testid={position === "top" ? "contract-publish-button" : "contract-publish-button-bottom"}>
        {saving === "publish" ? <Loader2 className="animate-spin" /> : <Send />}
        Pubblica
      </Button>
    </div>
  </div>
);